@use "@fukuri-admins/ui/layout" as *;

.wrapper {
  display: flex;
  gap: spacing("8");
  align-items: center;
  flex-shrink: 0;
}

.label {
  color: text("High");

  @include typography("Jp/14_W3");
}

.trigger {
  width: 214px;
}
